export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7109_11777)">
                <path
                    d="M30.9375 5.625H11.25V15.75H30.9375C31.8695 15.75 32.625 14.9945 32.625 14.0625V7.3125C32.625 6.38052 31.8695 5.625 30.9375 5.625Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.125 27.5625L28.125 15.75L22.5 15.75L22.5 27.5625C22.5 29.1158 23.7592 30.375 25.3125 30.375C26.8658 30.375 28.125 29.1158 28.125 27.5625Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.5 13.5V7.875H6.35164C6.61361 7.875 6.87199 7.81401 7.10631 7.69685L11.25 5.625V15.75L7.10631 13.6782C6.87199 13.561 6.61361 13.5 6.35164 13.5H4.5Z"
                    stroke="#3EAE60"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M22.5 21.375H24.75" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22.5 24.75H24.75" stroke="#3EAE60" strokeWidth="1.6875" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7109_11777">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
